import { render, staticRenderFns } from "./calendar-remove.vue?vue&type=template&id=a56a88b8&scoped=true&"
import script from "./calendar-remove.vue?vue&type=script&lang=js&"
export * from "./calendar-remove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a56a88b8",
  null
  
)

export default component.exports